module.exports = __webpack_public_path__ + "assets/img/bind1.3d815273.png";